import React from 'react';
import useSortableData from '../../../hooks/useSortableData';
import { SortableLabel, Table } from '../index';
import { Label, TableBody, TableHeader, TableRow } from '../../atoms';

interface SortableTableProps<T> {
  data: T[];
  columns: Array<{
    label: string;
    key?: keyof T; // Optional key for empty columns
  }>;
  renderRow: (item: T, index: number) => React.ReactNode;
  showEditButtonHeader?: boolean;
  showDeleteButtonHeader?: boolean;
  showDownloadButtonHeader?: boolean;
}

const SortableTable = <T,>({
  data,
  columns,
  renderRow,
  showEditButtonHeader = true,
  showDeleteButtonHeader = true,
  showDownloadButtonHeader = false,
}: SortableTableProps<T>) => {
  const { items, requestSort, sortConfig } = useSortableData(data);

  return (
    <Table>
      <TableHeader>
        <TableRow header={true}>
          {columns.map((column, idx) =>
            column.key ? (
              <SortableLabel
                key={idx}
                content={column.label}
                onClick={() => requestSort(column.key!)}
                sortDirection={
                  sortConfig?.key === column.key ? sortConfig.direction : null
                }
              />
            ) : (
              <Label key={idx} content="" /> // Render an empty Label if no key is present
            )
          )}
          {showDeleteButtonHeader && <Label />}
          {showEditButtonHeader && <Label />}
          {showDownloadButtonHeader && <Label />}
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item, index) => renderRow(item, index))}
      </TableBody>
    </Table>
  );
};

export default SortableTable;
